import React from "react";
import { createGlobalStyle } from "styled-components";
import ScrollAnimation from "react-animate-on-scroll";
import PT from "prop-types";

// import { up } from "~/src/config/vars";

const ScrollAnim = ({ type, children, delay, duration, className }) => {
    return (
        <ScrollAnimation
            animateOnce={true}
            animateIn={type}
            delay={delay}
            duration={duration}
            className={`${className} type_${type}`}
        >
            {children}
        </ScrollAnimation>
    );
};

ScrollAnim.defaultProps = {
    type: "slideInDown",
    delay: 0,
    duration: 0.5,
};

ScrollAnim.propTypes = {
    type: PT.oneOf([
        "slideInDown",
        "slideInDownBig",
        "slideInDownSmall",
        "slideInRight",
        "slideInRightSmall",
    ]),
    children: PT.any,
    delay: PT.number,
    duration: PT.number,
    className: PT.string,
};

export const ScrollAnimStyle = createGlobalStyle`
    .animated {
        transition: transform 0.5s, opacity 0.6s;
    }
    @media (prefers-reduced-motion: reduce), (print) {
        .animated {
            animation-iteration-count: 1;
        }
    }
    .type_slideInDown {
        &.animated:not(.slideInDown) {
            transform: translateY(-40px);
            opacity: 0;
        }
    }

    .type_slideInRight {
        &.animated:not(.slideInRight) {
            transform: translateX(30px);
            opacity: 0;
        }
    }
    .type_slideInDownSmall {
        &.animated:not(.slideInDownSmall) {
            transform: translateY(-20px);
            opacity: 0;
        }
    }
    .type_slideInRightSmall {
        &.animated:not(.slideInRightSmall) {
            transform: translateX(20px);
            opacity: 0;
        }
    }
`;

export default ScrollAnim;
